























import Vue from 'vue'
import Component from 'vue-class-component'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'

@Component<RadiusSlider>({
  props: {
    text: String
  }
})

export default class RadiusSlider extends Vue {
  /**
   * Props variables
   */
  text: string | undefined

  /**
   * Component state variables
   */
  radius: number = 50

  /**
   * Lifecycle
   */
  mounted() {
    this.radius = LocationModule.locations[0] ? LocationModule.locations[0].radius : 50
  }

  /**
   * Getters
   */


  /**
   * Methods
   */
   radiusValueChanged() {
    if(this.radius > 300)
      this.radius = 300
    else if(this.radius < 1)
      this.radius = 1

    this.$emit('radiusChanged', this.radius)
   }
}
